var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row px-4 sizer"},[_c('div',{staticClass:"col-12",staticStyle:{"padding":"0"}},[_c('ibox',{attrs:{"title":"Banners"},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var setLoading = ref.setLoading;
return [_c('Form',{attrs:{"slot":"content"},on:{"loading":setLoading},slot:"content"})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }